var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.773 4.288L9.061 8l3.712 3.712-1.06 1.061L8 9.061l-3.712 3.712-1.061-1.06L6.939 8 3.227 4.288l1.06-1.061L8 6.939l3.712-3.712 1.061 1.06z","fill":"currentColor","fillRule":"evenodd"}));
}

CloseInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
